import type { CaptureOptions, CaptureSource } from '../contracts';
import { measureAudioLevel } from './level';

/** Read with each PCM frame, using the same input clock without an extra timer. */
export function createSourceMeters(
  context: AudioContext,
  opened: Array<{ source: CaptureSource; stream: MediaStream }>,
  report?: CaptureOptions['onSourceLevels'],
) {
  const meters = report
    ? opened.map(({ source, stream }) => {
        const input = context.createMediaStreamSource(stream);
        const analyser = context.createAnalyser();
        analyser.fftSize = 2048;
        input.connect(analyser);
        return { source, input, analyser, samples: new Float32Array(analyser.fftSize) };
      })
    : [];
  return {
    read() {
      if (!report) return;
      const levels: Partial<Record<CaptureSource, number>> = {};
      for (const meter of meters) {
        meter.analyser.getFloatTimeDomainData(meter.samples);
        levels[meter.source] = measureAudioLevel(meter.samples);
      }
      report(levels);
    },
    release() {
      for (const meter of meters) {
        meter.input.disconnect();
        meter.analyser.disconnect();
      }
    },
  };
}
